import api from '@/utils/api'
import {Commit} from 'vuex'
import sso from '@/utils/sso'

import MENU_ALL from '../../menu_list'
import ROUTER_ALL from '../../new_router'


declare interface User {
  image: string, // 头像地址
  name: string,
  login: string,
  email?: string,
  tenantId?: string,
  id?: number,
  mis: string,
  file_outgoing_permission: string
}

interface State {
  userinfo: User,
  menu_list: any[]
}

/**
 * 构建菜单列表
 * @param user_type
 * @returns {null}
 */
let build_menu = (user_type) => {
  function format(item_list) {
    if (!item_list || item_list.length === 0) {
      return null
    }
    return item_list.filter((item) => {
      // 首先，添加children
      item.children = format(item.children)
      if (!item.auth || item.auth.length === 0) {
        return true
      }
      // 支持单个用户，多个角色
      return item_in_array(user_type, item.auth)
    })
  }

  return format(MENU_ALL)
}

/**
 * 构建路由列表
 * @param user_type
 * @returns {null}
 */
let build_router = (user_type) => {
  function format(item_list) {
    if (!item_list || item_list.length === 0) {
      return null
    }
    return item_list.filter((item) => {
      // 首先，添加children
      item.children = format(item.children)
      if (!item.auth || item.auth.length === 0) {
        return true
      }
      // 支持单个用户，多个角色
      return item_in_array(user_type, item.auth)
    })
  }

  return format(ROUTER_ALL)
}

/**
 * src中至少一个包含在target里面
 * @param src
 * @param target
 */
function item_in_array(src: any[], target: any[]) {
  for (let i = 0; i < src.length; i++) {
    if (target.indexOf(src[i]) !== -1) {
      return true
    }
  }
  return false
}

const state: State = {
  userinfo: {
    id: undefined,
    name: '',
    image: '',
    login: '',
    tenantId: '',
    mis: '',
    file_outgoing_permission: ''
  },
  menu_list: []
};

const getters = {
  get_login_user: (state: State) => state.userinfo,
  userinfo: (state: State) => state.userinfo,
  get_menu_list: (state: State) => state.menu_list,
};

const mutations = {
  GET_USERINFO(state: State, userinfo: User) {
    state.userinfo = userinfo
  },
  set_menu_list(state, menus) {
    state.menu_list = menus
  },
  set_router_list(state, routers) {
    state.router_list = routers
  }
};

const actions = {
  async getUserInfo(context: { commit: Commit }) {
    return api.get('/api/distribute/home/queryLoginUser').then(res => {
      let result = res.data;
      if (res.hasOwnProperty('status') && res['status'] === 401) {
        sso.logout();
        return
      }
      if (result.hasOwnProperty('status') && parseInt(result['status']) === 401) {
        sso.logout();
        return
      }
      context.commit('GET_USERINFO', res.data);
    }).catch(error => {
      console.log(error);
    })
  },
  async logout() {
    sso.logout()
  },
  async build_router(context) {
    await context.dispatch('getUserInfo');
    let user = context.state.userinfo;
    let user_type = String(user.usertype);
    let user_type_list: String[] = [];
    if (user_type && user_type !== '') {
      user_type_list.push(user_type);
    }
    if (user.file_outgoing_permission === '1') {
      user_type_list.push('file_outgoing');
    }
    if (user.file_trace_audit_permission === '1') {
      user_type_list.push('file_trace_audit');
    }
    // 构建菜单列表
    let menus_list = build_menu(user_type_list);
    context.commit('set_menu_list', menus_list);
    // 构建路由列表
    return build_router(user_type_list);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}
